<app-page-header [heading]="'Cost Sheet'" [icon]="'fa-file-excel-o'" style="height:100px;"></app-page-header>
<div *ngIf="user_rights.ADD == '1'" class="page-panel">
  <div class="row">
    <div class="form-group col-lg-4">
      <label>From</label>
      <input (ngModelChange)="fromdate = $event" [max]="getToday()" [ngModel]="fromdate | date:'yyyy-MM-dd'"
             class="form-control " id="date" name="date" type="date">
    </div>
    <div class="form-group col-lg-4">
      <label>To</label>
      <input (ngModelChange)="todate = $event" [max]="getToday()" [ngModel]="todate | date:'yyyy-MM-dd'"
             class="form-control " id="todate" name="todate" type="date">
    </div>
    <div class="form-group col-lg-4">
      <label></label><br>
      <button (click)="listCostSheet();" class="btn btn-info btn-sm ng-star-inserted" type="button">&nbsp;Search&nbsp;
      </button>

    </div>
    <div class="form-group col-lg-12 text-right">
      <label></label><br>
      <button (click)="ExportToExcel()" *ngIf="(stock_data | json) != '[]'" class="btn btn-info btn-sm"
              title="Export as XLSX">Export to XLSX&nbsp;<i class="fa fa-file-excel-o"></i></button>&nbsp;
      <app-report-pdf *ngIf="(stock_data | json) != '[]'" targetId="printReport" fileName="Cost_sheet_report.pdf" titleName="COST SHEET REPORT"></app-report-pdf>
      <br>
    </div>
    <div class=" col-12" id="printReport">
      <table #table class="table tbl table-bordered" style="background-color: #f3f8fd">
        <thead>
        <tr class="text-center">
          <th width="5%">Sl</th>
          <th width="15%">Date</th>
          <th width="15%">Invoice</th>
          <th class="text-left">Customer</th>
          <th width="15%" class="text-right"> Rate of purchae</th>
          <th width="15%" class="text-right">Rate of sale</th>
          <th width="15%" class="text-right">Margin</th>
        </tr>
        <tr *ngIf="(stock_data | json) == '[]'">
          <td class="text-center" colspan="7">No data to list</td>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let stock of stock_data;let i=index">
          <td class="text-center">{{ i + 1 }}</td>
          <td class="text-center"> {{ stock.INVOICE_DATE }}</td>
          <td (click)="open(saledetails);sale_items(stock.SALE_ID)" class="text-center text-primary"
              style="cursor: pointer">{{ stock.INVOICE_NUMBER }}
          </td>
          <td> {{ stock.CUSTOMER_NAME }}</td>
          <td class="text-right">{{ round(stock.PURCHASE) | number : '1.2-2' }}</td>
          <td class="text-right">{{ round(stock.SALE) | number : '1.2-2' }}</td>
          <td class="text-right">{{ round(stock.MARGIN) | number : '1.2-2' }}</td>
        </tr>
        </tbody>
        <tfoot>
        <tr>
          <td colspan="6" style="font-weight: bolder;font-size: 14px;" class="text-right">Total</td>
          <td class="text-right"
              style="font-weight: bolder;font-size: 14px;">{{ round(margin_total)| number : '1.2-2' }}
          </td>
        </tr>
        </tfoot>
      </table>
    </div>
  </div>
</div>
<ng-template #saledetails let-modal>
  <div class="modal-header">
    <div class="pull-right">
      <h3 class="modal-title" id="modal-basic-title">
        Particular List
      </h3>
    </div>
    <div class="pull-right text-right">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </div>
    <button (click)="modal.dismiss('Cross click')" aria-label="Close" class="close" type="button">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="tab-pane active">
      <div class="tab-content">
        <div class="panel panel-default">
          <div class="panel-heading"></div>
        </div>
        <div id="printInvoice">
          <div class="header-space">&nbsp;</div>
          <div class="header col-md-12">

            <div class="col-md-4 pull-left">
              <ng-container *ngIf="institution.INSTITUTION_LOGO">
                <img alt="" height="150" ngSrc="{{logo_path+institution.INSTITUTION_LOGO}}" width="150">
              </ng-container>
            </div>
            <div class="col-md-8 pull-right text-right" style="padding-right: 0;">
              <ng-container *ngIf="institution">
                <h5 class="name"><b>{{ institution.INSTITUTION_NAME }}</b></h5>
                <div style="line-height: 0.5em;"><label>{{ institution.INSTITUTION_ADDRESS }}</label></div>
                <div style="line-height: 0.5em;"><label>{{ institution.INSTITUTION_CITY }}
                  ,&nbsp;{{ institution.INSTITUTION_COUNTRY_NAME }}</label></div>
                <div style="line-height: 0.5em;"><label>Ph :&nbsp;{{ institution.INSTITUTION_PHONE_NO }}</label></div>
                <div style="line-height: 0.5em;"><label>Email :&nbsp;{{ institution.INSTITUTION_EMAIL }}</label></div>
                <div style="line-height: 0.5em;"><label>VAT
                  IN&nbsp;&nbsp;:&nbsp;&nbsp;{{ institution.INSTITUTION_VAT_NO }},&nbsp;State Code&nbsp;&nbsp;:&nbsp;&nbsp;{{ institution.TIN_NUMBER }}</label>
                </div>

              </ng-container>
            </div>
          </div>
          <div>&nbsp;</div>
          <div class="clearfix"></div>
          <h5 class="text-center">TAX INVOICE</h5>
          <br>
          <div>&nbsp;</div>
          <div *ngIf="saled" class="col-lg-12">
            <div class="col-8 pull-left " style="padding-left: 0;">
              <div *ngIf="saled.PATIENT_NAME" class="row">
                <div class="col-10">
                  <label> Customer &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;</label><label> :
                  &nbsp;&nbsp;{{ saled.CUSTOMER_NAME }}</label><label
                  *ngIf="saled.CUSTOMER_ADDRESS">,&nbsp;{{ saled.CUSTOMER_ADDRESS }}</label><label
                  *ngIf="saled.CUSTOMER_PHONE">&nbsp;{{ saled.CUSTOMER_PHONE }}</label>
                </div>
              </div>
              <div *ngIf="saled.PAYMENT_TYPE" class="row">
                <div class="col-12">
                  <label>Payment Type&nbsp;&nbsp;</label>
                  <label class="text-left">
                    <ng-container *ngIf="saled.PAYMENT_TYPE == 1">:&nbsp;&nbsp; Cash</ng-container>
                    <ng-container *ngIf="saled.PAYMENT_TYPE == 0">:&nbsp;&nbsp; Card</ng-container>
                    <ng-container *ngIf="saled.PAYMENT_TYPE == 2">:&nbsp;&nbsp; Cheque</ng-container>
                    <ng-container *ngIf="saled.PAYMENT_TYPE == 3">:&nbsp;&nbsp; Bank</ng-container>
                  </label>
                </div>
              </div>
            </div>
            <div class="col-4 pull-right text-right" style="padding-right: 0;">

              <div *ngIf="saled.INVOICE_NUMBER"><label> Invoice No&nbsp;&nbsp; :&nbsp;
                &nbsp;&nbsp;{{ saled.INVOICE_NUMBER }}</label></div>
              <div *ngIf="saled.SALE_DATE"><label> Invoice Date
                &nbsp;&nbsp;&nbsp;:&nbsp;&nbsp;&nbsp;{{ utils.date(saled.SALE_DATE) }}</label></div>
            </div>
            <div class="clearfix"></div>
            <div class="clearfix"></div>
            <div class="clearfix"></div>
            <table class=" container  col-md-12 printtable">
              <thead>
              <tr style="border-bottom: 1px solid #000;border-top: 1px solid #000;">

                <th class="text-left" width="3%">#</th>
                <th class="text-left">Item</th>
                <th class="text-left" width="10%">HSN Code</th>
                <th class="text-center" width="8%">MRP</th>
                <th class="text-center" width="8%">Rate</th>
                <th class="text-center" width="4%">Qty</th>
                <th class="text-center" width="5%">UOM</th>
                <th class="text-center" width="9%">Price</th>
                <th class="text-center" width="6%">VAT %</th>
                <th class="text-center" width="8%">VAT Amt</th>
                <th class="text-center" width="8%">Flood Cess</th>
                <th class="text-right" width="8%">Total</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let item of item_list;let i=index">
                <td class="text-left">{{ i + 1 }}</td>
                <td class="text-left"> {{ item.TRADE_NAME }}</td>
                <td class="text-left">{{ item.HSN_CODE }}</td>
                <td class="text-center">{{ item.MRP }}</td>
                <td class="text-center">{{ item.UNIT_PRICE }}</td>
                <td class="text-center">{{ item.QUANTITY }}</td>
                <td class="text-center">{{ item.SHORT_FORM }}</td>
                <td class="text-center">{{ item.PRICE }}</td>
                <td class="text-center">{{ item.VAT }}</td>
                <td class="text-center">{{ item.VAT_AMOUNT }}</td>
                <td class="text-center">{{ item.FLOOD_CESS }}</td>
                <td class="text-right">{{ item.TOTAL }}</td>
              </tr>
              <tr style="border-bottom: 1px solid #000;"></tr>
              </tbody>
            </table>
            <div class="clearfix">&nbsp;</div>
            <div class="clearfix">&nbsp;</div>
            <div class="clearfix">&nbsp;</div>
            <div class="clearfix">&nbsp;</div>
            <table>
              <th></th>
            </table>
            <div *ngIf="saled" class="  col-md-12" style="text-align:right;border-top: 1px solid #000;">
              Gross amount&nbsp;&nbsp;: &nbsp;&nbsp;{{ gross | number : '1.2-2' }}
              <ng-container *ngIf="saled && saled.DISCOUNT > 0">
                <br>
                Discount &nbsp;&nbsp;:&nbsp;&nbsp; {{ saled.DISCOUNT }}
              </ng-container>
              <ng-container *ngIf="saled && saled.FREIGHT_CHARGE > 0">
                <br>
                Frieght/Handling charge &nbsp;&nbsp;:&nbsp;&nbsp; {{ saled.FREIGHT_CHARGE }}
              </ng-container>
            </div>
            <div class=" col-md-12"
                 style="text-align:right;font-weight: bolder;font-size:18px;border-bottom-style:double;border-top-style:double;">
              Net bill amount : {{ price_total | number : '1.2-2' }}
            </div>
            <div class="clearfix"></div>

            <div class=" col-md-12">
              <span>Amount in words &nbsp;&nbsp;&nbsp;:&nbsp;&nbsp;&nbsp;</span>
              <span style="text-transform:capitalize;">&nbsp;{{ numberToWords }} &nbsp;Rupees only </span>
              <div *ngIf="save_rate > 0" class="pull-right text-right">You saved Rs {{ save_rate }}/- &nbsp;&nbsp;</div>
            </div>

            <div class="  col-md-12 clearfix" style="border-bottom: 1px solid #000"></div>

            <div class="clearfix"></div>
            <div class="clearfix"></div>
            <div class="clearfix"></div>
            <div class="clearfix"></div>
            <table style="width: 100%;">
              <tr>
                <td style="width: 70%;vertical-align: top;">
                  <table class="table table-bordered vat" style="width: 100%;">
                    <tr class="text-center">
                      <th width="3%">VAT %</th>
                      <th width="10%">Taxable value</th>
                      <th class="text-center">VAT <br>
                          <span class="pull-left">&nbsp;&nbsp;&nbsp;%</span>
                          <span class="pull-right">Amount&nbsp;&nbsp;&nbsp;</span>
                      </th>
                      <th class="text-center">Flood Cess <br>
                        <span class="pull-left">&nbsp;&nbsp;&nbsp;%</span>
                        <span class="pull-right">Amount&nbsp;&nbsp;&nbsp;</span>
                      </th>
                    </tr>
                    <tr *ngFor="let tax of vat_list">
                      <td class="text-center">{{ tax.VAT }}</td>
                      <td class="text-center">{{ (tax.TAXABLE_VALUE)| number : '1.2-2' }}</td>
                      <td width="6%">
                          <label class="pull-left">{{ tax.VAT }}</label>
                          <label class="pull-right">{{ (tax.VAT_VALUE)| number : '1.2-2' }}</label>
                      </td>
                      <td width="6%">
                        <label class="pull-left">1.00</label>
                        <label class="pull-right">{{ (tax.FLOOD_CESS)| number : '1.2-2' }}</label>
                      </td>
                    </tr>
                  </table>
                </td>
                <td style="width: 30%;vertical-align: top;">
                  <table class="table table-bordered vat" style="width: 100%;">
                    <tr>
                        <th>VAT</th>
                        <th class="text-right"> {{ total_vat | number : '1.2-2' }}</th>
                    </tr>
                    <tr>
                      <th>Flood Cess</th>
                      <th class="text-right"> {{ total_flood | number : '1.2-2' }}</th>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
            <div *ngIf="saled.SHIPPING_ADDRESS" class=" col-md-4 text-left"><br>
              <label style="font-weight: bold;">Shipping Address&nbsp;&nbsp;</label>
              <label [innerHTML]='saled.SHIPPING_ADDRESS | nl2br ' class="text-left"></label>
            </div>
            <div class="  col-md-12 clearfix" style="border-bottom: 1px solid #000"></div>
          </div>
        </div>

      </div>
    </div>
  </div>
</ng-template>
